import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../../app/api';
import GoBack from '../subsidiary/GoBack/GoBack';
import Loader from '../subsidiary/Loader/Loader';
import {
  CODE_LABELS,
  fetchCbrRatesFromWeb,
  formatRate,
  sortRates,
} from '../../utils/exchangeRates';
import styles from './ExchangeRates.module.css';

const ExchangeRates = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatedAt, setUpdatedAt] = useState('');
  const [rates, setRates] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (token) {
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
      const response = await api.get('/exchange-rates');
      setRates(sortRates(response.data?.rates));
      setUpdatedAt(response.data?.updated_at || '');
    } catch (apiError) {
      try {
        const fallback = await fetchCbrRatesFromWeb();
        setRates(sortRates(fallback.rates));
        setUpdatedAt(fallback.updated_at || '');
      } catch (fallbackError) {
        setError(
          apiError?.response?.data?.message ||
            fallbackError?.message ||
            'Не удалось загрузить курсы валют',
        );
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading && !rates.length) {
    return <Loader />;
  }

  return (
    <section className="main">
      <div className="content-wrapper">
        <GoBack text="Назад" />
        <div className="page-title-container">
          <h1 className="page-title">Курс валют</h1>
        </div>
        <p className={styles.subtitle}>
          Официальный курс ЦБ РФ
          {updatedAt ? `. На дату: ${updatedAt}` : ''}
        </p>
        {error ? (
          <p className={styles.error}>{error}</p>
        ) : (
          <div className={styles.list}>
            {rates.map((rate) => (
              <div key={rate.code} className={styles.card}>
                <div className={styles.code}>
                  {CODE_LABELS[rate.code] || `${rate.code} → RUB`}
                </div>
                <div className={styles.value}>{formatRate(rate)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ExchangeRates;
